import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "modal", "emailFields", "tokenStep", "sendTokenButton" ]

  static values = {
    show: Boolean,
    required: Boolean,
    tokenSent: Boolean
  }

  connect() {
    if (this.showValue && this.hasModalTarget) {
      this.modalInstance = new bootstrap.Modal(this.modalTarget, {
        backdrop: this.requiredValue ? "static" : true,
        keyboard: !this.requiredValue
      })
      this.modalInstance.show()
    }

    if (this.tokenSentValue) {
      this.showTokenStep()
    }
  }

  showTokenStep() {
    if (!this.hasTokenStepTarget) return

    this.tokenStepTarget.classList.remove("d-none")

    if (this.hasEmailFieldsTarget) {
      this.emailFieldsTarget.querySelectorAll("input").forEach((input) => {
        input.readOnly = true
      })
    }

    if (this.hasSendTokenButtonTarget) {
      this.sendTokenButtonTarget.classList.add("d-none")
    }
  }
}
